import { Transition } from "@headlessui/react";

function TransitionWorkflowPage(props: { show: boolean; header?: React.ReactNode; children: React.ReactNode }) {
  return (
    <Transition show={props.show} className="absolute top-0 flex flex-col flex-shrink-0 w-full h-full overflow-hidden" unmount>
      {props.header}
      <div className="flex flex-row-reverse flex-1 overflow-hidden">
        {props.children}
      </div>
    </Transition>
  );
}

export default TransitionWorkflowPage;
